module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Dramatis Personæ")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oedipus.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The Priest of Zeus.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Creon.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Chorus of Theban Elders.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Teiresias.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Jocasta.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Messenger.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Herd of Laius.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Second Messenger.")])]), _c('p', {
    staticClass: "center1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Scene: Thebes. Before the Palace of Oedipus")])])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44343f90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Chapter01.vue
// module id = 72
// module chunks = 0